import React,{useState,useEffect} from "react";
import { useSelector } from 'react-redux';


///Styles
import { FiMoreVertical } from 'react-icons/fi'
import {ContainerLoading,Container,Content,Groups,TableProducts,Button} from './styles'

///Components
import { ExportFiles } from '../ExportFiles'
import {SpaceLoader} from '../../../../loaders/spaceLoader';


///Services
import { api } from "../../../../../services/api";
import { download_csv } from "../JsonToCsv";

import {formatMoney} from '../../../../../Utils/formatMoney';
import moment from "moment";



export function ExpensesList(){

    const rankingDatas = useSelector(state => state.modalCentralized.datasComponent)

    const [isOpenExcelButton, setIsOpenExcelButton] = useState(false);
    const [myBusinessFinances,setMyBusinessFinances] = useState([]);
    const [page, setPage] = useState(1)
    const [loading,setLoading] = useState(true);
    const [loadingButton, setLoadingButton] = useState(false)

    async function handleFetchNewDates(){
        setLoadingButton(true)
        const response = await api.post(`/getResumeFinancial?page=${page}`,
        {
            business:  rankingDatas.business,
            salesChannels: rankingDatas.salesChannels,
            creditsOrDebts:("D").toUpperCase(),
            endDate: rankingDatas.endDate,
            startDate: rankingDatas.startDate
        },
        {
            headers: {
                'Content-Type': 'application/json',
                 //token: localStorage.getItem('@Inoveclube:token')
            }
        });

        const {datas,next_page} = response.data
        const data = handleData(datas);
        setMyBusinessFinances([...myBusinessFinances,...data])
        setPage(next_page)
        setLoadingButton(false);
    }

    useEffect(() => {
        async function loadMovs(){
            const response = await api.post('/getResumeFinancial?page=1',
            {
                business:  rankingDatas.business,
                salesChannels: rankingDatas.salesChannels,
                creditsOrDebts:("D").toUpperCase(),
                endDate: rankingDatas.endDate,
                startDate: rankingDatas.startDate
            },
            {
                headers: {
                    'Content-Type': 'application/json',
                     //token: localStorage.getItem('@Inoveclube:token')
                }
            });
           
            const {datas,next_page} = response.data;

            setMyBusinessFinances(handleData(datas));
            setPage(next_page);
            setLoading(false);
            
        }
        loadMovs()
    },[rankingDatas.business, rankingDatas.endDate, rankingDatas.startDate, rankingDatas.salesChannels]);

    ///Agrupando as empresas e suas movimentacoes no meu JSON   
    const handleData = (data) => {
        const result = Object.entries(data.reduce((acc, {RowNum,date,idBusiness,nameBusiness,namePerson,numberOrder,orderType,paymentType,value,cnpj,idCustomized,discount}) => {
            acc[nameBusiness] = (acc[nameBusiness] || []);
            acc[nameBusiness].push({
                RowNum,
                date,
                idBusiness,
                namePerson,
                numberOrder,
                orderType,
                paymentType,
                value,
                discount
            });
            return acc;
        },{}))
        .map(([key, value]) => ({name: key, children: value}));
        return result
    }    

    ///Baixando o relatório em Excel
    async function handleDownloadCSV(){
        setLoading(true);

        const response = await api.post('/getResumeFinancial?page=0',
        {
            business:  rankingDatas.business,
            salesChannels: rankingDatas.salesChannels,
            creditsOrDebts:("D").toUpperCase(),
            endDate: rankingDatas.endDate,
            startDate: rankingDatas.startDate
        },
        {
            headers: {
                'Content-Type': 'application/json',
                 //token: localStorage.getItem('@Inoveclube:token')
            }
        })

        const {datas} = response.data
        const bussArr = datas;

        const newArr = bussArr.map((data) => {
            return {
                Codigo: data.idBusiness,
                Id_Customizado: data.idCustomized,
                CNPJ: data.cnpj.replace(/^(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, "$1.$2.$3/$4-$5"),
                Empresa: data.nameBusiness,
                Cliente: data.namePerson,
                Numero_Venda: data.numberOrder,
                Data: moment(data.date).utcOffset(0).format('DD/MM/YYYY HH:mm:ss'),
                Tipo: data.orderType,
                Forma_Pagamento: data.paymentType,
                //Desconto: Number(data.discount).toFixed(2),
                Valor: Number(data.value).toFixed(2),
            }
        })
    
        download_csv(newArr, 'Despesas')
        setLoading(false);
    }    

    if(loading){
        return(
            <ContainerLoading>
                <SpaceLoader colorLoader="var(--colorFontsCardsDashboard)" />
            </ContainerLoading>
        )
    }

    return(
        <Container>
            <div className="seeMore">
                <FiMoreVertical
                    onClick={() => setIsOpenExcelButton(!isOpenExcelButton)}
                />

                <ExportFiles 
                    handleDownloadCSV={handleDownloadCSV}
                    isOpen={isOpenExcelButton}
                    setIsOpen={setIsOpenExcelButton}
                />
            </div>

            <Content>
                {
                    myBusinessFinances.map((business) => {
                        return(
                            <Groups key={business.name}>
                                <h3>&#8226;{business.name}</h3>

                                <TableProducts>
                                    <thead>
                                        <tr>
                                            <th>Cliente</th>
                                            <th>Forma de Pagamento</th>
                                            {/*<th>Desconto</th>*/}
                                            <th>Data</th>
                                            <th>Tipo Mov</th>
                                            <th>Valor</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {
                                            business.children.map((item) =>{
                                                return(
                                                    <tr key={item.numberOrder}>
                                                        <td>{item.namePerson}</td>
                                                        <td>{item.paymentType}</td>
                                                        <td>{moment(item.date).utcOffset(0).format('DD/MM/YYYY HH:mm:ss')}</td>
                                                        <td>{item.orderType}</td>
                                                        {/*<td className={item.discount > 0 && 'discount'}>{formatMoney(item.discount)}</td>*/}
                                                        <td>{formatMoney(item.value)}</td>
                                                    </tr>
                                                )
                                            })
                                        }

                                        <tr>
                                            <td>Total</td>
                                            <td></td>
                                            <td></td>
                                            <td></td>
                                            <td>
                                            {
                                                formatMoney(
                                                    business.children.map((item) => {
                                                        return item.value
                                                    })
                                                    .reduce((value,next) => {
                                                        return value + next
                                                    })
                                                )
                                            }
                                            </td>
                                        </tr>
                                    </tbody>
                                </TableProducts>
                            </Groups>
                        )
                    })
                }
            </Content>

            {
                page !== null &&
                <Button onClick={handleFetchNewDates} loadingButton={loadingButton}>
                    {
                        loadingButton ? 
                        '...aguarde'
                        :
                        'Ver mais'
                    }
                </Button>
            }
        </Container>
    )
}